import { Component, Input, OnInit } from '@angular/core';
import { PortalService } from '@career/core/services/portal.service';

@Component({
  selector: 'app-default-panels',
  templateUrl: './default-panels.component.html',
  styleUrls: ['./default-panels.component.scss']
})
export class DefaultPanelsComponent implements OnInit {

  @Input() scope;
  constructor(private portalService: PortalService) { }

  get isSky(): boolean {
    return this.portalService.getPortalTemplate().value === 'sky';
  }

  ngOnInit(): void {
  }

}
